import styles from "./TurnOption.module.css";
import morning from "../../assets/svgs/morning.svg";
import morningHighlight from "../../assets/svgs/morningHighlight.svg";
import afternoon from "../../assets/svgs/afternoon.svg";
import afternoonHighlight from "../../assets/svgs/afternoonHighlight.svg";
import free from "../../assets/svgs/free.svg";
import freeHighlight from "../../assets/svgs/freeHighlight.svg";

const TurnOption = ({ activeTurno, onSelect, disabled, isMobile }) => {
  const options = [
    { id: 1, label: "Mañana", icon: morning, highlight: morningHighlight },
    { id: 2, label: "Tarde", icon: afternoon, highlight: afternoonHighlight },
    { id: 3, label: "Libre", icon: free, highlight: freeHighlight },
  ];

  return (
    <div className={`${styles.container} ${isMobile ? styles.mobileContainer : ""}`}>
      {options.map((opt) => {
        const isActive = String(activeTurno) === String(opt.id);

        return (
          <div
            key={opt.id}
            className={`${styles.option} ${isActive ? styles.active : ""} ${
              disabled ? styles.disabled : ""
            } ${isMobile ? styles.mobileOption : ""}`}
            role="button"
            tabIndex={0}
            onClick={() => !disabled && onSelect?.(opt.id)}
            onKeyDown={(e) => {
              if (!disabled && (e.key === "Enter" || e.key === " ")) onSelect?.(opt.id);
            }}
          >
            <img
              src={isActive ? opt.highlight : opt.icon}
              alt={opt.label}
              className={styles.icon}
            />
            <span>{opt.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default TurnOption;
